import { TraitTypeColor } from '../traitTypes/TraitTypeColor';
import { TraitRegistryCategory } from '../TraitRegistryCategory';
import { TraitTypeSelect } from '../traitTypes/TraitTypeSelect';
import { TraitTypeNumericWithSlider } from '../traitTypes/TraitTypeNumericWithSlider';
import { TraitTypeSelectWithPreview } from '../traitTypes/TraitTypeSelectWithPreview';
export class TraitRegistryCssFont extends TraitRegistryCategory {
    label = 'Font';
    constructor(parent) {
        super(parent);
        super.init();
    }
    color = () => new TraitTypeColor( /*{
        label: 'Schriftfarbe',
        init: '#333'
      }*/);
    fontSize = () => new TraitTypeNumericWithSlider({
        /*    label: 'Schriftgröße',
        init: 14,
        min: 8,
        max: 200, */
        roundDecimals: 0,
    });
    fontSizeManual = () => new TraitTypeNumericWithSlider({
        /*  label: 'Manuelle Schriftgröße',
        init: 14,
        min: 8,
        max: 200,
        aspectsTemplate: { core: ['scale_fontSize'] } as any, */
        key: 'fontSizeManual',
        creates: ['fontSize', 'jsx_attr_data_fontsizemanual'],
        createTraits: ({ at }) => {
            return [
                { ...at.trait.serialized, key: 'fontSize', value: at.trait.value },
                { key: 'jsx_attr_data_fontsizemanual', value: 1 },
            ];
        },
    });
    fontWeight = () => new TraitTypeSelect( /*{
      init:
        'bold'
        label: 'Schriftstärke',
      select: [
        ['normal', 'Normal'],
        ['bold', 'Fett'],
        ['bolder', 'breiter'],
        ['lighter', 'Dünner'],
        [100],
        [200],
        [300],
        [400],
        [500],
        [600],
        [700],
        [800],
        [900]
      ]
    }*/);
    fontStyle = () => new TraitTypeSelect( /*{
      default:
        'normal'
      label: 'Schriftstil',
      init: 'italic',
      select: [['normal', 'Normal'], ['italic', 'kursiv'], ['oblique', 'schräg']]
    }*/);
    fontVariant = () => new TraitTypeSelect( /*{
     // default: 'normal'
        label: 'Schriftbuchstaben',
      init: 'small-caps',
      select: [['normal', 'Normal'], ['small-caps', 'GROSSBUCHSTABEN']]
    }*/);
    lineHeight = () => new TraitTypeSelect( /*{
    //  default: 'normal'
       label: 'Zeilenhöhe',
      init: '150%',
      select: [['normal', 'Normal'], ['120%'], ['150%'], ['180%'], ['200%'], ['250%'], ['300%'], ['20px'], [1.3]]
    }*/);
    letterSpacing = () => new TraitTypeNumericWithSlider( /*{
      label: 'Zeichenabstand',
      init: 3,
      min: -10,
      max: 50
    }*/);
    fontFamily = () => new TraitTypeSelect({
        stylesheet: ({ at }) => {
            if (at.trait.value.includes('schulschrift')) {
                return '/lib/schulschriften/schulschriften.css';
            }
            return [];
        },
        /*label: 'Schriftart',
        init: 'Arial, Helvetica, sans-serif',
        select: [
          ['Georgia, serif'],
          ["'Palatino Linotype', 'Book Antiqua', Palatino, serif"],
          ["'Times New Roman', Times, serif"],
          ['Arial, Helvetica, sans-serif'],
          ["'Arial Black', Gadget, sans-serif"],
          ["'Comic Sans MS', cursive, sans-serif"],
          ['Impact, Charcoal, sans-serif'],
          ["'Lucida Sans Unicode', 'Lucida Grande', sans-serif"],
          ['Tahoma, Geneva, sans-serif'],
          ["'Trebuchet MS', Helvetica, sans-serif"],
          ['Verdana, Geneva, sans-serif'],
          ["'Courier New', Courier, monospace"],
          ["'Lucida Console', Monaco, monospace"],
          ['schulschrift_lesen, sans-serif']
        ] */
    });
    whiteSpace = () => new TraitTypeSelect( /* {
       label: 'Leerzeichen',
      init: 'nowrap',
      select: [['normal', 'Normal'], ['nowrap'], ['pre'], ['pre-line'], ['pre-wrap']]
    } */);
    textShadow = () => new TraitTypeSelectWithPreview({
        /* label: 'Textschatten',
        init: 'custom',
        select: [
          ['custom'],
          ['4px 4px 2px #999999'],
          ['5px 5px 3px rgba(155, 100, 55, 0.2)'],
          ['-1px -1px 0 hsl(80, 70%, 35%), -2px -2px 1px hsl(80, 70%, 35%)']
        ], */
        css({ at }) {
            if (at.trait.value !== 'custom')
                return [{ k: 'textShadow', v: at.trait.value }];
            return [
                {
                    k: 'textShadow',
                    v: `${at.scaledValueOf.textShadowH}px ${at.scaledValueOf.textShadowV}px ${at.scaledValueOf.textShadowBlurRadius}px ${at.valueOf.textShadowColor}`,
                },
            ];
        } /*,
          aspectsTemplate: { core: ['textShadowH', 'textShadowV', 'textShadowBlurRadius', 'textShadowColor'] } */,
    });
    textShadowH = () => new TraitTypeNumericWithSlider({
        default: 2,
        /*label: 'Textschatten Horizonal',
        min: -50,
        max: 50,
        hidden: true */
    });
    textShadowV = () => new TraitTypeNumericWithSlider({
        default: 2,
        /* label: 'Textschatten Vertikal',
        min: -50,
        max: 50,
        hidden: true */
    });
    textShadowBlurRadius = () => new TraitTypeNumericWithSlider({
        default: 2,
        /*  label: 'Textschatten Radius',
        min: 0,
        max: 50,
        hidden: true */
    });
    textShadowColor = () => new TraitTypeColor( /*{
        label: 'Textschatten Farbe',
        default: '#666',
        hidden: true
      }*/);
    textDecoration = () => new TraitTypeSelect();
    /* label: 'Textstrich',
        init: 'line-through',
        select: [
          ['none', 'kein'],
          ['underline', 'unterstrichen'],
          ['line-through', 'durchgestrichen'],
          ['overline', 'Überstrichen'],
          ['blink', 'Blinkend']
        ] */
    textDecorationColor = () => new TraitTypeColor( /*{
        label: 'Strichfarbe'
      }*/);
    textDecorationLine = () => new TraitTypeSelect();
    /* init: 'line-through',
        label: 'Textstrichlinie',
        select: [
          ['none', 'kein'],
          ['underline', 'unterstrichen'],
          ['line-through', 'durchgestrichen'],
          ['overline', 'Überstrichen'],
          ['blink', 'Blinkend']
        ] */
    textDecorationStyle = () => new TraitTypeSelect( /*{
       label: 'Strichstil',
      init: 'solid',
      select: [['solid'], ['double'], ['dotted'], ['dashed'], ['wavy']]
    } */);
    textAlign = () => new TraitTypeSelect( /*{
        label: 'Textausrichtung',
      init: 'center',
      select: [['left'], ['right'], ['center'], ['justify']]
    } */);
    userSelect = () => new TraitTypeSelect( /*{
       label: 'Can select text element',
      init: 'none',
      select: [['auto'], ['none'], ['text'], ['all']]
    }*/);
    wordBreak = () => new TraitTypeSelect( /*{
        select: [['keep-all'], ['break-all'], ['normal']]
      }*/);
    wordWrap = () => new TraitTypeSelect( /*{
        select: [['break-word'], ['normal']]
      } */);
    textTransform = () => new TraitTypeSelect({
    /* label: 'Text Transform',
  init: 'uppercase',
  select: [['none'], ['capitalize'], ['uppercase'], ['lowercase'], ['full-width'], ['full-size-kana']] */
    });
}
